<template>
    <div>
        <section id="home_banner" class="banner header-banner full">
            <article v-for="(slide, index) in slides" :key="index" :style="{ backgroundImage: 'url(' + slide.img + ')' }">
                <img :src="slide.img" :alt="slide.altText" />
                <div class="inner">
                    <header>
                        <p class="hide-on-mobile">{{slide.subText}}</p>
                        <h2>{{slide.title}}</h2>
                    </header>
                </div>
            </article>
            <ul class="indicators hide-on-tablet-and-smaller">
                <li v-for="(slide, index) in slides" :key="index" v-on:click="selectSlide(index)" class="">
                </li>
            </ul>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Banner',
    props: {
        slides : Array
    },
    data() {
        return {
            timer: null,
            currentIndex: 0
        }
    },
    mounted: function() {
        this.startSlide();
    },
    methods: {
        startSlide: function() {
            this.toggleActiveClass(true);
            this.timer = setInterval(this.next, 5000);
        },
        next: function() {
            this.toggleSlide(this.currentIndex + 1)
        },
        prev: function() {
            this.toggleSlide(this.currentIndex - 1)
        },
        selectSlide: function(index) {
            if(index != this.currentIndexAbsolute) {
                this.toggleSlide(index);
                clearInterval(this.timer);
                this.timer = setInterval(this.next, 5000);
            }
        },
        toggleSlide: function(index){
            this.toggleActiveClass(false);
            this.currentIndex = index;
            this.toggleActiveClass(true);
        },
        toggleActiveClass(isAddClass) {
            var article = this.$el.querySelectorAll("#home_banner article")[this.currentIndexAbsolute];
            var indicator = this.$el.querySelectorAll("ul.indicators > li")[this.currentIndexAbsolute];

            if (isAddClass === true) {
                article.classList.add("active");
                indicator.classList.add("visible");
            } else {
                article.classList.remove("active");
                indicator.classList.remove("visible");
            }
        },
    },
    computed: {
        currentIndexAbsolute: function() {
            return Math.abs(this.currentIndex) % this.slides.length;
        }
    }
}
</script>


<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.9s ease;
    overflow: hidden;
    visibility: visible;
    position: absolute;
    width:100%;
    opacity: 1;
}

.fade-enter,
.fade-leave-to {
    visibility: hidden;
    width:100%;
    opacity: 0;
}

</style>